const featureToggles = {
  // Allow-list of user IDs who see gated features on production while the
  // global toggle is still off (e.g. PAYG, Apply with Ari).
  featureFlagOverrideUserIds: [2, 341236, 492347],
  // PAYG credit purchase on pricing page (TP-187). When true and TEST_START_DATE has passed,
  // users are split A/B: even user IDs = control (PAYG hidden), odd = treatment (PAYG visible).
  paygCreditsPricingPage: false,
  // Apply with Ari on Easy Apply (TP-498). Default off. Not PostHog.
  // Gate via helpers/applyWithAriFeature.js using __CLOUD_ENV__ (not
  // config.isProduction / NODE_ENV — those are true on staging too):
  // non-production always on; production needs this true OR an override user.
  applyWithAri: false,
};

export default featureToggles;
